import React, { useState, useEffect } from 'react'
import {
  Button,
  Input,
  Row,
  Modal,
  Col,
  Checkbox,
  message,
  Form,
  Spin,
  InputNumber
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import {
  loadAddCashModalShow,
  loadCashListingLoading,
  loadCashListingDataLoading,
  loadOpenCloseListingDataLoad,
  loadClosedRegData
} from '../../../appRedux/actions/Sell'
import {
  loadOpenClosePrintData,
  loadShowPrintOpenClose,
  notAllowMsgCheck
} from '../../../appRedux/actions'
import { PRINT_TYPES } from '../../../constants/StoreSetting'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'

const CashAdd = props => {
  const modalRole = props.role
  const { addAllow, removeAllow } = props
  const history = useHistory()
  const store = useStore()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxIsShowModal = useSelector(
    ({ Sell }) => Sell.cashManageAddModalShow
  )

  const getReduxCashListingDataLoading = useSelector(
    ({ Sell }) => Sell.cashListingDataLoading
  )

  const getReduxOpenListingDataLoad = useSelector(
    ({ Sell }) => Sell.openCloseListingDataLoad
  )

  const [getIsSpinning, setIsSpinning] = useState(false)
  const [getIsCashOutOrPettyOut, setIsCashOutOrPettyOut] = useState('1') //1 for cash 2 for petty
  const [getIsCashInOrPettyIn, setIsCashInOrPettyIn] = useState('1') //1 for cash 2 for petty

  // React.useEffect(() => {
  //   if (!checkIsWeb().exist) {
  //     postDataToApp(
  //       PostAppTypes.PAGE_HEADER,
  //       modalRole == '1'
  //         ? 'sell.cashlisting.subtitlebtn2'
  //         : 'sell.cashlisting.removecash'
  //     )
  //   }
  // }, [])

  async function postCashService (body, behaviour) {
    // ;
    const cashInOutService = ds.postCashManagementInOutService(body, behaviour)
    await cashInOutService
      .then(res => {
        if (res && res.msg && res.msg == 'Saved') {
          if (res.type && res.type == PRINT_TYPES.cashMove) {
            dispatch(loadOpenClosePrintData(res))
            dispatch(loadShowPrintOpenClose(true))
          }
          dispatch(loadClosedRegData({}, true))
          dispatch(loadCashListingDataLoading(!getReduxCashListingDataLoading))
          dispatch(loadOpenCloseListingDataLoad(!getReduxOpenListingDataLoad)) //to load data in Open/Close -> OpenListing
          form.resetFields()
        } else {
          message.error('Something went wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      })
  }

  const handleOk = e => {
    form.resetFields()
    dispatch(loadAddCashModalShow(false))
  }

  const handleCancel = () => {
    form.resetFields()
    dispatch(loadAddCashModalShow(false))
  }

  const onFinishFailed = errorInfo => {
    message.error('Please Try Again...')
  }

  // const onFinish = async (values) => {};
  const onFinish = values => {
    // ;
    let id = localStorage.getItem('cashManageID')
    if (id && id != '' && values.amount) {
      let body
      if (modalRole == '1') {
        if (getIsCashInOrPettyIn == '1') {
          if (id && id != '') {
            body = {
              CashManagementID: id,
              CashIn: values.amount,
              Note: values.note
            }
          }
        } else if (getIsCashInOrPettyIn == '2') {
          body = {
            CashManagementID: id,
            PettyCashIn: values.amount,
            Note: values.note
          }
        }
      } else if (modalRole == '2') {
        if (getIsCashOutOrPettyOut == '1') {
          body = {
            CashManagementID: id,
            CashOut: values.amount,
            Note: values.note
          }
        } else if (getIsCashOutOrPettyOut == '2') {
          body = {
            CashManagementID: id,
            PettyCashOut: values.amount,
            Note: values.note
          }
        }
      }

      postCashService(body, BEHAVIOUR_TYPE.POST)
    }
    form.resetFields()
    dispatch(loadCashListingLoading(true))
    // dispatch(loadCashListingDataLoading(!getReduxCashListingDataLoading));
    // dispatch(loadIsRegistorLoading(true));
    dispatch(loadAddCashModalShow(false))
  }

  function onCashCheckChange (e) {
    if (modalRole == '1') {
      if (getIsCashInOrPettyIn == '1') {
        setIsCashInOrPettyIn('2')
      } else if (getIsCashInOrPettyIn == '2') {
        setIsCashInOrPettyIn('1')
      }
    } else if (modalRole == '2') {
      if (getIsCashOutOrPettyOut == '1') {
        setIsCashOutOrPettyOut('2')
      } else if (getIsCashOutOrPettyOut == '2') {
        setIsCashOutOrPettyOut('1')
      }
    }
  }

  return (
    <div className='custom-promoadd-maindiv'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.loadcash' />}
        spinning={getIsSpinning}
        size='large'
      >
        <Modal
          className='AddCash-Modal'
          title={
            modalRole == '1' ? (
              <IntlMessages id='sell.cashlisting.subtitlebtn2' />
            ) : (
              <IntlMessages id='sell.cashlisting.removecash' />
            )
          }
          visible={getReduxIsShowModal}
          onOk={handleOk}
          onCancel={handleCancel}
          centered={true}
          // width={"402px"}
          footer={
            <Button
              form='cashInOut'
              className={modalRole == '1' ? 'dk-btn-add' : 'dk-btn-cancel'}
              type='primary'
              htmlType='submit'
              size='large'
              disabled={addAllow}
            >
              {modalRole == '1' ? (
                <IntlMessages id='sell.cashlisting.subtitlebtn2' />
              ) : (
                <IntlMessages id='sell.cashlisting.subtitlebtn1' />
              )}
            </Button>
          }
        >
          <Row>
            <Col span={12}>
              <Checkbox
                checked={
                  modalRole == '1'
                    ? getIsCashInOrPettyIn == '1'
                      ? true
                      : false
                    : getIsCashOutOrPettyOut == '1'
                    ? true
                    : false
                }
                onChange={e => {
                  onCashCheckChange(e)
                }}
              >
                <strong>
                  {modalRole == '1' ? (
                    <IntlMessages id='sell.cashlisting.cashin' />
                  ) : (
                    <IntlMessages id='sell.cashlisting.cashout' />
                  )}
                </strong>
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox
                name='asd'
                checked={
                  modalRole == '1'
                    ? getIsCashInOrPettyIn == '2'
                      ? true
                      : false
                    : getIsCashOutOrPettyOut == '2'
                    ? true
                    : false
                }
                onChange={e => {
                  onCashCheckChange(e)
                }}
              >
                <strong>
                  {modalRole == '1' ? (
                    <IntlMessages id='sell.cashlisting.pettycashin' />
                  ) : (
                    <IntlMessages id='sell.cashlisting.pettycashout' />
                  )}
                </strong>
              </Checkbox>
            </Col>
          </Row>

          <Row style={{ marginTop: '30px' }}>
            <Col span={24}>
              <Form
                // {...formItemLayout}
                form={form}
                name='cashInOut'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  prefix: '86'
                }}
                layout='vertical'
                scrollToFirstError
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='amount'
                  label={
                    <span>
                      <strong>
                        <IntlMessages id='sell.cashlisting.amount' />
                      </strong>
                      {/* <Tooltip title="Brand Name"></Tooltip> */}
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please enter amount'
                    }
                  ]}
                  // style={{ width: "100px" }}
                >
                  <InputNumber
                    type='number'
                    min={0}
                    max={100000000}
                    step={0.1}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right'
                  name='note'
                  label={
                    <span>
                      <strong>
                        <IntlMessages id='sell.cashlisting.note' />
                      </strong>
                      {/* <Tooltip title="Brand Description"></Tooltip> */}
                    </span>
                  }
                  rules={[
                    {
                      max: 255,
                      message: <IntlMessages id='sell.cashlisting.charallow' />
                    }
                  ]}
                >
                  <Input.TextArea
                    placeholder='Provide a short description for this cash movement.'
                    rows={3}
                    // onChange={getCardPromoDesc}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Modal>
      </Spin>
    </div>
  )
}

export default CashAdd
